<div class="parent-container">
  <saf-product-header tasks-aria-label="Product" global-aria-label="Global">
    <saf-logo
      slot="logo"
      appearance="full-color"
      product-name="Document Understanding" />
    <div slot="tasks">
      @if (product$ | async) {
        <saf-select
          value="{{ (product$ | async)?.name }}"
          id="select-product"
          invalid="false"
          data-testid="current-product-menu-item"
          aria-invalid="false"
          class="product-button-text">
          @for (
            availableProduct of availableProductsDetails$ | async;
            track availableProduct
          ) {
            <saf-listbox-option
              [attr.data-testid]="
                'other-product-menu-item-' + availableProduct.id
              "
              [title]="availableProduct.id"
              (click)="switchProduct(availableProduct.id)">
              {{ availableProduct.name }}
            </saf-listbox-option>
          }
        </saf-select>
      }
    </div>
    <div slot="global">
      <saf-product-header-item
        appClickOutside
        (clickOutside)="handleClickOutside(HeaderMenus.Help)">
        <saf-button
          appearance="tertiary"
          icon-only=""
          id="documentation-header-btn"
          (click)="toggleVisibleMenu(HeaderMenus.Help)">
          <saf-icon icon-name="circle-question" />
          <saf-sr-only> Help </saf-sr-only>
        </saf-button>
      </saf-product-header-item>
      <saf-product-header-item
        data-testid="current-user-menu-item"
        appClickOutside
        (clickOutside)="handleClickOutside(HeaderMenus.UserProfile)">
        <saf-button
          appearance="tertiary"
          icon-only=""
          (click)="toggleVisibleMenu(HeaderMenus.UserProfile)">
          <saf-icon icon-name="circle-user" />
          <saf-sr-only> User profile </saf-sr-only>
        </saf-button>
      </saf-product-header-item>
    </div>
    <div slot="global">
      @switch (visibleMenu) {
        @case (HeaderMenus.Help) {
          <saf-menu class="menu">
            <saf-menu-item (click)="goToLink(developmentUrl + 'scalar')">
              API Reference (OpenAPI)
            </saf-menu-item>
            <saf-menu-item
              (click)="
                goToLink(
                  'https://helix.thomsonreuters.com/static-sites/site-builds/labs_du-portal-documentation/du-portal-documentation/welcome.html'
                )
              ">
              Product Documentation
            </saf-menu-item>
          </saf-menu>
        }
        @case (HeaderMenus.UserProfile) {
          <saf-menu class="menu">
            <saf-menu-item (click)="logout()">Sign out</saf-menu-item>
          </saf-menu>
        }
      }
    </div>
  </saf-product-header>
</div>
